export default __webpack_public_path__ + "aed4eb29fb67000178f1d319deee8aee.png";